import { Colors } from "@fuse/styles/color";

export const containerStyle: React.CSSProperties = {
  marginTop: 74,
  marginLeft: 202,
  marginRight: 202,
};
export const topHeading: React.CSSProperties = {
  fontWeight: "700",
  marginBottom: 20,
  color: Colors.secondary,
  fontFamily: "DM Sans",
};
export const topSubTitle: React.CSSProperties = {
  fontWeight: "500",
  color: "rgba(21, 20, 57, 0.40)",
};

export const textContainer: React.CSSProperties = {
  textAlign: "start",
};
export const smallHead: React.CSSProperties = {
  fontSize: 14,
  fontWeight: "700",
  letterSpacing: 2,
  marginBottom: 10,
  color: Colors.secondary,
  fontFamily: "DM Sans",
  textAlign: "left",
};
export const smallSubTitle: React.CSSProperties = {
  fontSize: 16,
  color: "rgba(21, 20, 57, 0.40)",
  fontFamily: "DM Sans",
  textAlign: "left",
};
